export const US_STATES: Record<string, string> = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AS: "American Samoa",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District Of Columbia",
  FL: "Florida",
  GA: "Georgia",
  GU: "Guam",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  MP: "Northern Mariana Islands",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VI: "Virgin Islands",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
};

export const US_TERRITORIES: Record<string, string> = {
  AS: "American Samoa",
  GU: "Guam",
  MP: "Northern Mariana Islands",
  PR: "Puerto Rico",
  VI: "Virgin Islands",
};

export const CANADA_PROVINCES: Record<string, string> = {
  // includes territories
  AB: "Alberta",
  BC: "British Columbia",
  MB: "Manitoba",
  NB: "New Brunswick",
  NL: "Newfoundland and Labrador",
  NS: "Nova Scotia",
  NT: "Northwest Territories",
  NU: "Nunavut",
  ON: "Ontario",
  PE: "Prince Edward Island",
  QC: "Quebec",
  SK: "Saskatchewan",
  YT: "Yukon",
};

export enum CountryCode {
  US = "US",
  CA = "CA",
  // US territories
  AS = "AS",
  GU = "GU",
  MP = "MP",
  PR = "PR",
  VI = "VI",
}

export const US_DOMESTIC_COUNTRIES: Record<string, string> = {
  US: "United States",
  ...US_TERRITORIES,
};

export const COUNTRIES: Record<string, string> = {
  US: "United States",
  CA: "Canada",
  ...US_TERRITORIES,
};

/**
 * Mirror of the backend `accounts.constants.AddressReasonCode` enum.
 * Lob's `verification_data.deliverability_analysis.dpv_footnotes` is mapped
 * to one of these by the controller and returned on the verify response.
 */
export enum AddressReasonCode {
  MissingStreetNumber = "missing_street_number",
  InvalidStreetNumber = "invalid_street_number",
  MissingUnit = "missing_unit",
  InvalidUnit = "invalid_unit",
  UnnecessaryUnit = "unnecessary_unit",
  AddressNotFound = "address_not_found",
  UnknownUndeliverable = "unknown_undeliverable",
}

/**
 * User-facing copy per reason code. Owned by the FE so product tweaks ship as
 * a single-file change without needing a backend deploy.
 */
export const ADDRESS_REASON_CODE_MESSAGES: Record<AddressReasonCode, string> = {
  [AddressReasonCode.MissingStreetNumber]:
    "This address is missing a street number. Please enter a street number to continue.",
  [AddressReasonCode.InvalidStreetNumber]:
    "This street number isn't valid for this street. Please update the address to continue.",
  [AddressReasonCode.MissingUnit]:
    "This address requires an apartment or unit number. Please enter an apartment or unit number to continue.",
  [AddressReasonCode.InvalidUnit]:
    "This apartment or unit number isn't valid for this address. Please update the address to continue.",
  [AddressReasonCode.UnnecessaryUnit]:
    "This address doesn't use apartment or unit numbers. Please remove the apartment or unit number to continue.",
  [AddressReasonCode.AddressNotFound]:
    "We couldn't verify this address. Please enter a valid address to continue.",
  [AddressReasonCode.UnknownUndeliverable]:
    "This address may be undeliverable. Please enter a valid address to continue.",
};
